<template>
  <v-container>
    <apexchart
      width="100%"
      height="322"
      :type="chart.type"
      :options="chart.options"
      :series="chart.series"
      :labels="chart.options.labels"
    ></apexchart>
  </v-container>
</template>
<script>
import VueApexCharts from 'vue-apexcharts';

export default {
  name: 'PieChart',
  components: {
    apexchart: VueApexCharts,
  },
  props: [
    'chartData',
    'toolTypes',
  ],
  data() {
    return {
      chart: {
        type: 'pie',
        options: {
          // チャートの動的な部分
          labels: this.chartData.map(function( value ) {
            if (this.length > 0) {
              let result = this.filter(function(toolType) {
                  return toolType.technology_id == this.technology_id;
              }, value);
              return result[0].name;
            }
            return value.name;
          }, this.toolTypes),
          plotOptions: {
            pie: {
              size: 300,
              offsetX: 0,
              offsetY: 0,
              polygons: {
                strokeColors: "#5E00BC",
                strokeWidth: 1,
                connectorColors: undefined,
                fill: {
                  colors: "#5E00BC"
                }
              }
            }
          },
          fill: {
            colors: ["#C388FF", "#889FFF", "#C9EFA8", "#DFDC8A", "#DDB0A8", "#D3D3D3", "#D9FFDD", "#FF889A", "#88DFFF", "#C8FF88"],
          }
        },
        // チャートの動的な部分
        series: this.chartData.map(function( value ) {
          return Number(value.score);
        }),
      }
    }
  },
}
</script>
